export const GET_WISHS = "GET_WISHS";
export const FILTER_WISHS = "FILTER_WISHS";
export const ADD_WISH = "ADD_WISH";
export const EDIT_WISH = "EDIT_WISH";
export const GET_WISH = "GET_WISH";
export const RESET_WISH = "RESET_WISH";
export const WISHS_ERROR = "WISHS_ERROR";
